<script>
import PopUp from '@/components/PopUp.vue'
import message from '@/helpers/message'
import Form from '@/components/Form/Form.vue'
import CalendarDays from '@/components/Calendar/CalendarDays.vue'
import AdminBookingsBlock from '@/views/Admin/AdminBookingsBlock.vue'
export default {
    components:{ PopUp, Form, AdminBookingsBlock,CalendarDays },
    data() {
        return {          
            bookings: [],
            blockings: [],
            isCancelingBooking: false,
            selectedDay: { day: null, date: null, isBlocked: false },
            bookingItem: null,
            selectedItem: null,
            blockingPopup: { isOpen: false },
            infoFormPublic: [                   
                { sections: [{ sectionName: 'Information om bokaren', classes: "g-100", inputs: [ 
                            { type: 'text', prop: 'full_name', title: 'Namn', classes: "g-50", required: false },
                            { type: 'switch', prop: 'is_public_booking', title: 'Bokad via publika sidan', classes: "g-50", required: false },
                            { type: 'text', prop: 'email', title: 'Email', classes: "g-50", required: false },
                            { type: 'text', prop: 'mobile_no', title: 'Mobilnummer', classes: "g-50", required: false },
                            { type: 'switch', prop: 'send_reminder_to_mobile_no', title: 'Använder SMS för bekräftelse och påminnelse', classes: "g-100", required: false },
                        ]
                    }, { sectionName: 'Längd på bokningen', classes: "g-100", inputs: [
                        { type: 'select', prop: 'duration', title: '', classes: "g-100", required: false}, 
                        ]
                    }
                    ],
                        backgroundColor: this.$colors.form.backgroundColor,
                        borderColor: this.$colors.form.borderColor
                }],
            infoFormInternal: [                   
                { sections: [{ sectionName: 'Information om bokaren', classes: "g-100", inputs: [ 
                            { type: 'text', prop: 'full_name', title: 'Namn', classes: "g-50", required: false },
                            { type: 'switch', prop: 'is_public_booking', title: 'Bokad via publika sidan', classes: "g-50", required: false }                          
                        ]
                    }, { sectionName: 'Längd på bokningen', classes: "g-100", inputs: [
                        { type: 'select', prop: 'duration', title: '', classes: "g-100", required: false}, 
                        ]
                    }
                    ],
                        backgroundColor: this.$colors.form.backgroundColor,
                        borderColor: this.$colors.form.borderColor
                }]
        };
    },
    computed: {      
        slotMinutes() {
            return this.bookingItem?.hour_calender_layout == 'Timmar' ? 60 : 30;
        },
        rowHeight() {
            return this.slotMinutes == 60 ? 30 : 21;
        },
        timeSlots() {
            if (!this.bookingItem) {
                return [];
            }

            const slots = [];
            for (let hours = this.bookingItem.day_available_start_hour; hours < this.bookingItem.day_available_end_hour; hours++) {
                if (this.slotMinutes == 60) {
                    slots.push({ minutes: hours * 60, timeLabel: `${String(hours).padStart(2, '0')}:00`, showLabel: true });
                } else {
                    slots.push({ minutes: hours * 60, timeLabel: `${String(hours).padStart(2, '0')}:00`, showLabel: true });
                    slots.push({ minutes: hours * 60 + 30, timeLabel: `${String(hours).padStart(2, '0')}:30`, showLabel: false });
                }
            }
            return slots;
        },
        selectedDayBookings() {
            if(this.selectedDay.day == null) {
                return [];
            }

            return this.getBookingsForDay();
        },
        selectedDayBlockings() {
            if(this.selectedDay.day == null || this.bookingItem == null) {
                return [];
            }

            const dayStart = new Date(this.selectedDay.date.getFullYear(), this.selectedDay.date.getMonth(), this.selectedDay.date.getDate(), 0, 0, 0, 0);
            const dayEnd = new Date(this.selectedDay.date.getFullYear(), this.selectedDay.date.getMonth(), this.selectedDay.date.getDate() + 1, 0, 0, 0, 0);
            const availabilityStart = this.getTimeInMinutes(this.bookingItem.day_available_start_time);
            const availabilityEnd = this.getTimeInMinutes(this.bookingItem.day_available_end_time);

            return this.blockings
                .map(blocking => {
                    const blockingStart = new Date(blocking.start_date);
                    const blockingEnd = new Date(blocking.end_date);

                    if (blockingEnd <= dayStart || blockingStart >= dayEnd) {
                        return null;
                    }

                    const rangeStart = blockingStart > dayStart ? blockingStart : dayStart;
                    const rangeEnd = blockingEnd < dayEnd ? blockingEnd : dayEnd;
                    const rangeStartMinutes = rangeStart.getTime() <= dayStart.getTime() ? 0 : rangeStart.getHours() * 60 + rangeStart.getMinutes();
                    const rangeEndMinutes = rangeEnd.getTime() >= dayEnd.getTime() ? 24 * 60 : rangeEnd.getHours() * 60 + rangeEnd.getMinutes();
                    const clampedStartMinutes = Math.max(rangeStartMinutes, availabilityStart ?? 0);
                    const clampedEndMinutes = Math.min(rangeEndMinutes, availabilityEnd ?? 24 * 60);

                    if (clampedEndMinutes <= clampedStartMinutes) {
                        return null;
                    }

                    return {
                        start_time_in_minutes: clampedStartMinutes,
                        end_time_in_minutes: clampedEndMinutes,
                        formatted_start_time: this.formatMinutes(clampedStartMinutes),
                        formatted_end_time: this.formatMinutes(clampedEndMinutes),
                        description: blocking.description,
                        isBlocking: true
                    };
                })
                .filter(blocking => blocking != null);
        }     
    },
    created() {
        this.getBookingItem();
        this.getBookings();
    },
    methods: {       
        getTimeInMinutes(timeString) {
            if (timeString == null) {
                return null;
            }

            const [hours, minutes] = timeString.split(':').map(Number);
            return hours * 60 + minutes;
        },
        formatMinutes(minutes) {
            const hours = String(Math.floor(minutes / 60)).padStart(2, '0');
            const mins = String(minutes % 60).padStart(2, '0');
            return `${hours}:${mins}`;
        },
        getBookings()
        {
            var self = this;
            this.$communicator.get('bookings/'+this.$route.params.id +'/log')
            .then(function(data)
            {                 
                self.bookings = data;
            })
            .fail(function(error) {                  
            })  
            
            this.$communicator.get('bookings/'+this.$route.params.id +'/blockings')
            .then(function(data)
            {                 
                self.blockings = data;
            })
            .fail(function(error) {                  
            })  
        },     
        getBookingItem()
        {
            var self = this;
            this.$communicator.get('available-bookings/'+this.$route.params.id)
            .then(function(data)
            {                 
                self.bookingItem = data;
            })
            .fail(function(error) {                  
            })  
        },     
        cancelBooking()
        {
            var self = this;
            this.$communicator.post('cancel-booking/', this.selectedItem)
            .then(function(data)
            {          
                message.setSuccessMessage('Avbokningen lyckades och ett avbokningsmail är skickat.');   
                self.selectedItem = null;    
                self.getBookings();
            })
            .fail(function(error) {                  
            })  
        }, 
        getBookingsForDay() {
            const year = this.selectedDay.date.getFullYear();
            const month = String(this.selectedDay.date.getMonth() + 1).padStart(2, '0');
            const day = String(this.selectedDay.date.getDate()).padStart(2, '0');
            var dateString = `${year}-${month}-${day}`;
            return this.bookings.filter(booking => booking.formatted_start_date == dateString);
        },      
        getSlotEndMinutes(slot) {
            return slot.minutes + this.slotMinutes;
        },
        isSlotBooked(slot) {
            const slotEndMinutes = this.getSlotEndMinutes(slot);
            return this.selectedDayBookings.some(booking => slot.minutes < booking.end_time_in_minutes && slotEndMinutes > booking.start_time_in_minutes);
        },
        isSlotBlocked(slot) {
            const slotEndMinutes = this.getSlotEndMinutes(slot);
            return this.selectedDayBlockings.some(blocking => slot.minutes < blocking.end_time_in_minutes && slotEndMinutes > blocking.start_time_in_minutes);
        },
        getBookingBlockStyle(booking) {
            const durationMinutes = booking.end_time_in_minutes - booking.start_time_in_minutes;
            return {
                height: `${(durationMinutes / this.slotMinutes) * this.rowHeight}px`
            };
        },
        getBlockingBlockStyle(blocking) {
            const durationMinutes = blocking.end_time_in_minutes - blocking.start_time_in_minutes;
            return {
                height: `${(durationMinutes / this.slotMinutes) * this.rowHeight}px`
            };
        },
        createBlocking()
        {
            this.blockingItem = { id: 0, }
        }    
    }
  };
</script>
<template>
    <div v-fade-in  v-if="bookingItem">
        <main class="opacity-admin-bg overflow-auto position-relative">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'admin' }">Startsidan: Redaktör</router-link>
                &nbsp; >>  &nbsp;
                <router-link :to="{ name: 'adminBookings' }">Bokningar</router-link>
                &nbsp; >>  &nbsp;
                <b>Bokningskalendern</b>
            </div>
            <div class="float-right">
                <div class="selected-day blocked-dot"></div> = vald dag &nbsp;<span class="blocked-dot" style="background-color: rgb(189 162 162)"></span> = blockering &nbsp; &nbsp; &nbsp;
                <button class="btn btn-gray" @click="blockingPopup.isOpen = true">Hantera blockeringar</button>
            </div>
            <h2 class="text-left">Bokningskalender för {{ bookingItem.name }}</h2>
            <div class="calendar g-70">
                <CalendarDays :bookings="bookings" :blockings="blockings" :isAdmin="true" :selectedDay="selectedDay" :bookingItem="bookingItem"></CalendarDays>
            </div>
            <div class="g-30">       
                <div style="margin: 104px 0px 0px 20px;" v-if="selectedDay.day" :class="selectedDay.isBlocked ? 'blocked': ''">
                    <div v-for="(slot, index) in timeSlots" :key="slot.minutes">
                        <div class="day-row" :class="{ 'day-row-booked': isSlotBooked(slot), 'day-row-blocked': isSlotBlocked(slot) }" :style="{ 'height': rowHeight + 'px', 'border-top-style': slotMinutes == 30 && index % 2 === 1 ? 'dashed' : 'solid' }">
                            <div style="margin-top: -12px">{{ slot.showLabel ? slot.timeLabel : '' }}</div>   
                            <div v-for="booking in selectedDayBookings">
                                <div v-if="booking.start_time_in_minutes == slot.minutes" class="hour-occupied" :style="getBookingBlockStyle(booking)">
                                    {{ booking.formatted_start_time }} - {{ booking.formatted_end_time }} {{ booking.full_name ?? booking.comments }} <button v-if="!(booking.comments && booking.comments.includes('Återkommande bokning'))" class="btn btn-details float-right" @click="selectedItem = booking">Detaljer</button>
                                </div>    
                            </div>
                            <div v-for="blocking in selectedDayBlockings">
                                <div v-if="blocking.start_time_in_minutes == slot.minutes" class="hour-occupied hour-blocking" :style="getBlockingBlockStyle(blocking)">
                                    {{ blocking.formatted_start_time }} - {{ blocking.formatted_end_time }} Blockering{{ blocking.description ? ' - ' + blocking.description : '' }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="day-end-time">
                        <div style="margin-top: -12px">{{ bookingItem.day_available_end_time }}</div>
                    </div>
                </div>
            </div>
        </main>
    </div>
    <PopUp v-if="selectedItem" :width="'800px'" :bgColor="this.$colors.list.backgroundColor">
        <button class="btn btn-gray float-right" @click="selectedItem= null">Stäng</button>
        <div class="text-left">
            <h2>Bokning, {{ selectedItem.formatted_start_date_and_time }} - {{ selectedItem.formatted_end_time }}</h2>
        </div>
        <Form v-if="selectedItem.is_public_booking" :form="infoFormPublic" :item="selectedItem" :readOnly="true"></Form>
        <Form v-else :form="infoFormInternal" :item="selectedItem" :readOnly="true"></Form>

        <button class="btn btn-gray float-right" v-if="!isCancelingBooking" @click="isCancelingBooking = true">Avboka</button>
        <div v-if="isCancelingBooking" class="text-left">
            <label>Skicka med en kommentar som infogas i avbokningsmailet.</label>
            <textarea style="height: 80px" v-model="selectedItem.cancel_comment"></textarea>
            <button class="btn float-right" @click="cancelBooking">Avboka och skicka avbokningsmail</button>
        </div>
    </PopUp> 
    <div v-if="bookingItem">
        <AdminBookingsBlock :blockingPopup="blockingPopup" :blockings="blockings" :getBookings="getBookings" :bookingItemId="bookingItem.id"></AdminBookingsBlock>
    </div>
</template>
  <style scoped>
  .calendar {
    text-align: center;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;   
  }
  .weekdays, .days {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
    text-align: center;
  }
  .weekdays div {
    font-weight: bold;
  }
  .day, .empty {
    background: #efdab1;
    padding: 22px 10px 10px 10px;
    border: 1px solid #d3c499;
    height: 73px;
    border-radius: 3px;
    position: relative;
  }

  .day{
    cursor: pointer;
  }

  .day:hover {
    background-color: #f0e4cb !important;
  }

  .day span {
    position: absolute;
    top: 2px;
    left: 2px;
    font-style: italic;
  }

  .sunday {
    color: red;
    }

    .booking {
        font-size: 10px;
        text-align: left;
        padding: 2px 5px;
        margin-bottom: 1px;
        background-color:rgb(245, 150, 150);
        border-radius: 4px;
    }

    .more-bookings {
        font-size: 13px;

    }
    .day-row {
        border-top: 1px dashed #cbcaca;
        text-align: left;
        position: relative;
    }

    .day-row:hover {
        background-color: #f0e4cb;
    }

    .day-row-booked {
        background: linear-gradient(to right, transparent 55px, rgb(245, 150, 150) 55px);
    }

    .day-row-booked:hover {
        background: linear-gradient(to right, transparent 55px, rgb(245, 150, 150) 55px);
    }

    .day-row-blocked {
        background: linear-gradient(to right, transparent 55px, rgb(189 162 162) 55px);
    }

    .day-row-blocked:hover {
        background: linear-gradient(to right, transparent 55px, rgb(189 162 162) 55px);
    }

    .day-end-time {
        border-top: 1px dashed #cbcaca;
        text-align: left;
    }

    .hour-occupied {
        position: absolute;
    top: 0px;
    left: 55px;
    background-color: rgb(245, 150, 150);
    height: 22px;
    width: 80%;
    border-top: 1px solid red;
    font-size: 13px;
    padding: 1px 6px 0px 14px;
    z-index: 1;
    }

    .hour-blocking {
    background-color: rgb(189 162 162);
    border-top: 1px solid rgb(130 104 104);
    }

    .btn-details {
        border-radius: 6px;
    padding: 2px 10px;
    margin-top: 2px;
    font-size: 12px;
    }

    

    .blocked-dot
    {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        margin-bottom: -4px;
    }
    
    .selected-day {
        background-color: rgb(188 221 124) !important;

    }
  </style>
  
